import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _apiCount = 0;

  private _displayLoader: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public get displayLoader(): Observable<boolean> {
    return this._displayLoader.asObservable();
  }
  public set displayLoader(value: boolean) {
    this._displayLoader.next(value);
  }

  constructor() {}

  showLoader() {
    if (this._apiCount === 0) {
      this.displayLoader = true;
    }
    this._apiCount++;
  }

  hideLoader() {
    this._apiCount--;
    if (this._apiCount === 0) {
      this.displayLoader = false;
    }
  }
}
